import { badgeStatusRecipe } from '@repo/themes/styled-system/recipes';
import { styled, type HTMLStyledProps } from '@repo/themes/styled-system/jsx';

export const BadgeStatus = styled('div', badgeStatusRecipe);
export type BadgeProps = HTMLStyledProps<typeof BadgeStatus>;
